export default __webpack_public_path__ + "static/media/Congrats.882735cb.png";